import { GetGoogleSheetsAuthURLResponse } from "./../integration.service.d";
import { put, select } from "redux-saga/effects";
import { getGoogleSheetsAuthURLFailure, getGoogleSheetsAuthURLSuccess } from "../actionCreators";
import { IntegrationService } from "../integration.service";

export function* handleGetGoogleSheetsAuthURL() {
    try {
        const formId: string = yield select(state => state.forms.current._id);

        const response: GetGoogleSheetsAuthURLResponse = yield IntegrationService.getGoogleSheetsAuthURL(formId);
        yield put(
            getGoogleSheetsAuthURLSuccess({
                success: true,
                message: "",
                data: response.data.data,
            }),
        );
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to get Google Sheets authentication URL";
        yield put(getGoogleSheetsAuthURLFailure(errorMessage));
    }
}
